import { RaModule } from 'resources/RaModule';
import { ResourceIntent, ResourceName } from 'shared/enums';

export const LogsModule = RaModule.fromResourceProps({
  name: ResourceName.LOGS,
  intent: ResourceIntent.REGISTRATION
});
